export default __webpack_public_path__ + "static/media/contact.0e356a6a.jpg";